const VARIANT_PHASE_STATUSES = {
  'PROVEN_IN_TRANS': 'Proven in trans',
  'SUSPECTED_IN_TRANS': 'Suspected in trans',
  'UNKNOWN': 'Unknown'
};
export default VARIANT_PHASE_STATUSES;

